<template>
  <div class="wrap" style="layout-grid: 15.6pt">
    <div v-for="(item, index) in data" :key="index">
      <h3>{{ item.title }}</h3>
      <div v-for="(it, i) in item.data" :key="index + '-' + i">
        <p class="normal">
          <span>{{ it.txt }}</span>
          <b>{{ it.btxt }}</b>
        </p>
        <template v-if="it.tips">
          <p v-for="(tip, idx) in it.tips" :key="index + '-' + i + '-' + idx" class="sub_norma">
            <span>
              <span v-if="it.tips.length > 1">({{ idx + 1 }})</span>
              {{ tip.txt }}
            </span>
            <template v-if="tip.tips">
              <br />
              <span class="sub_norma_tip" v-for="(ttip, iidx) in tip.tips" :key="idx + '~' + iidx">
                — {{ ttip.txt }}
              </span>
            </template>
          </p>
        </template>
      </div>
    </div>
    <!-- <h3 class="MsoNormal " align="left" style="text-align: left; layout-grid-mode: char;text-indent: 21pt">
        <b><span style="font-family: 宋体; color: black">一、说明</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char;text-indent: 21pt">
        <span style="font-family: 宋体; color: black">
          本用户协议双方为厦门铸远教育科技有限公司（以下简称乐私塾）与乐私塾用户，本用户协议具有合同效力。
        </span>
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char;text-indent: 21pt">
        <span style="font-family: 宋体; color: black">
          本用户协议内容包括协议正文及所有乐私塾已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          用户在使用乐私塾提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。乐私塾有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，乐私塾将在网站及相关产品平台上刊载公告，通知予用户。如用户不同意相关变更，必须停止使用“服务”。经修订的协议一经在乐私塾公布后，立即自动生效。各类规则会在发布后生效，亦成为本协议的一部分。登录或继续使用“服务”将表示用户接受经修订的协议。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; text-indent: 21pt; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >用户确认本用户协议后，本用户协议即在用户和乐私塾之间产生法律效力。请用户务必在注册之前认真阅读全部用户协议内容，如有任何疑问，可向乐私塾咨询。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; text-indent: 21pt; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >(<span lang="EN-US">1</span
          >）无论用户事实上是否在注册之前认真阅读了本用户协议，只要用户点击协议正本下方的“确认”按钮并按照乐私塾注册程序成功注册为用户，用户的行为仍然表示其同意并签署了本用户协议。<span
            lang="EN-US"
            >&nbsp;</span
          ></span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; text-indent: 21pt; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >(<span lang="EN-US">2</span>）本协议不涉及用户与乐私塾其它用户之间因网络教育而产生的法律关系及法律纠纷。<span
            lang="EN-US"
            >&nbsp;</span
          ></span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b
          ><span style="font-family: 宋体; color: black">二、<span lang="EN-US">&nbsp;</span>定义</span></b
        >
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; text-indent: 21pt; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >乐私塾网络教育平台：乐私塾旗下全部网络教育产品平台，包括但不限于<span lang="EN-US">Web H5 </span
          >商城，乐私塾<span lang="EN-US">APP</span>，微信小程序等。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; text-indent: 21pt; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >用户及用户注册：用户必须是具备完全民事行为能力的自然人。无民事行为能力人、限制民事行为能力人不应注册为乐私塾用户，其与乐私塾之间的用户协议自始无效，乐私塾一经发现，有权立即注销该用户，并追究其使用乐私塾“服务”的一切法律责任。用户注册是指用户登录乐私塾网络教育平台，并按要求填写相关信息并确认同意履行相关用户协议的过程。用户因进行交易、获取有偿服务或接触乐私塾网络教育平台服务器而发生的所有应纳税赋，以及一切硬件、软件、服务及其它方面的费用均由用户负责支付。乐私塾仅作为网络教育培训平台。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b
          ><span style="font-family: 宋体; color: black">三、<span lang="EN-US">&nbsp;</span>用户权利和义务：</span></b
        >
      </h3>
      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"> <b> ※所有用户必须遵循</b></span>
      </p>
      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          （<span lang="EN-US">1</span
          >）遵守所有使用网络服务的网络协议、规定、程序和惯例；不得使用乐私塾从事违法活动；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          （<span lang="EN-US">2</span>）不得干扰或侵犯乐私塾的正常运行和其他用户的正常使用；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          （<span lang="EN-US">3</span>）未经允许，不得以任何形式下载或试图下载乐私塾的任何内容；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          （<span lang="EN-US">4</span>）用户购买的课程只允许个人使用，不能用于其他目的；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          （<span lang="EN-US">5</span>）从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black"> ※同时用户承诺：</span></b
        ><span lang="EN-US" style="font-family: 宋体; color: black"><br /> </span
        ><span style="font-family: 宋体; color: black">
          （<span lang="EN-US">1</span>）不得利用乐私塾网络教育平台制作、复制、查阅和传播下列信息：<span lang="EN-US"
            ><br /> </span
          ><span lang="EN-US"> -</span
          >任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；<span lang="EN-US"
            ><br />
          </span>
          <span lang="EN-US"> -</span>任何教唆他人进行违法犯罪行为的资料；<span lang="EN-US"><br /> </span>
          <span lang="EN-US"> -</span>不利于国内团结和社会安定的资料；<span lang="EN-US"><br /> </span>
          <span lang="EN-US"> -</span>任何不符合国家法律、法规规定的资料、信息；<span lang="EN-US"><br /> </span>
          <span lang="EN-US"> -</span>任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">2</span>）不得未经许可而非法进入其它个人或组织电脑系统；<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">3</span
          >）未经允许，不得对乐私塾网络教育平台中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span>）不得故意制作、传播计算机病毒等破坏性程序；<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">5</span>）法律规定的其他义务。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"
          >如果用户的行为违背上述两款规定，乐私塾可以做出独立判断并有权立即取消用户资格。用户应对自己在乐私塾网络教育平台上的违法行为承担全部法律责任。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black"> ※基于网络服务的特殊性，用户同意：</span></b
        ><span lang="EN-US" style="font-family: 宋体; color: black"><br /> </span
        ><span style="font-family: 宋体; color: black">
          （<span lang="EN-US">1</span>）在注册时按照注册提示提供准确用户名和密码以及详尽的个人资料；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">2</span
          >）在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为乐私塾提供所有服务的有效身份依据。<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">3</span>）用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span
          >）用户应自行负担因使用这种接入方式而产生的上网电话费、上网信息费及教育信息费。<span lang="EN-US"
            ><br />
          </span>
          用户的用户名、密码。<span lang="EN-US"><br /> </span>
          <span lang="EN-US"> </span>
          用户一旦注册成功，成为乐私塾网络课堂的正式用户后，应当对自己的用户名（亦称账号）、密码的安全性负全部责任。用户的密码只能由用户自己掌握。<span
            lang="EN-US"
            ><br />
          </span>
          <span lang="EN-US"> -</span
          >对于用户因账号或密码泄露造成的各种损失，乐私塾不承担任何责任。用户发现任何非法使用用户账号的情况，应立即通知乐私塾。<span
            lang="EN-US"
            ><br />
          </span>
          <span lang="EN-US"> -&nbsp;</span>用户应对以其用户名进行的所有活动和事件负责。<span lang="EN-US"
            ><br />
          </span>
          <span lang="EN-US"> -&nbsp;</span
          >一个听课账号只能由一个用户使用，不允许多个用户使用同一个听课账号，如果用户违反此规定，乐私塾将有权将此听课账号作为无效处理并保留追究法律责任的权利。<span
            lang="EN-US"
            ><br />
          </span>
          <span lang="EN-US"> -&nbsp;</span
          >用户应使用正版课程资料，对于涉嫌盗版听课账号，一经证实，乐私塾将有权将此听课账号做封号处理并保留追究法律责任的权利。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">四、关于乐私塾网络课堂的说明</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="margin-left: 0.05pt; text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"> （<span lang="EN-US">1</span>）</span
        ><span style="font-family: 宋体; color: #333333"
          >所有直播课程，一经购买（包括网上支付等各种购买方式），都不允许任何形式的退换。直播课程确有质量问题除外。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="margin-left: 0.05pt; text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black"> （<span lang="EN-US">2</span>）</span
        ><span style="font-family: 宋体; color: #333333"
          >所有直播课程都有听课有效期，用户应在指定日期前登录直播课堂。如果用户没有在最后期限之前登录直播课堂，课程将自动失效，乐私塾不在予以任何补偿。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">五、乐私塾的权利和义务：</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          乐私塾有义务在现有技术上维护整个网络教育平台的正常运行，并努力提升和改进技术，使用户网络教育活动得以顺利进行；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          对用户在注册使用乐私塾网络教育平台中所遇到的与交易或注册有关的问题及反映的情况，乐私塾应及时做出回复；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          对于用户在乐私塾网络教育平台上的不当行为或其它任何乐私塾认为应当终止服务的情况，乐私塾有权随时做出删除相关信息、终止服务提供等处理，而无须征得用户的同意；
          乐私塾应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于不可抗力或者其它非人为因素造成的服务的中断或停止，乐私塾不承担任何相应的责任。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          乐私塾网站内以任何形式表现的作品（包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等）的著作权，用户未经许可，不得擅自对乐私塾的包括电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯乐私塾知识产权的个人和组织，乐私塾和作品的著作权人将依法追究其民事或刑事责任。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          乐私塾享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          许可使用权：乐私塾对用户在网上发表的供学习交流的作品，享有独家的出版、发行和复制的权利。用户以此授予乐私塾及其关联公司独家的、全球通用的、永久的、免费的许可使用权利<span
            lang="EN-US"
            >&nbsp;(</span
          >并有权在多个层面对该权利进行再授权<span lang="EN-US">)</span>，使乐私塾及其关联公司有权<span lang="EN-US"
            >(</span
          >全部或部份地<span lang="EN-US">)&nbsp;</span
          >使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部资料数据（包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和<span
            lang="EN-US"
            >/</span
          >或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内；</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          乐私塾会在用户的计算机上设定或取用乐私塾网络教育平台<span lang="EN-US">cookies</span>。
          乐私塾允许那些在乐私塾网络教育平台上发布广告的公司到用户计算机上设定或取用<span lang="EN-US"
            >&nbsp;cookies&nbsp;</span
          >。 在用户登录时获取数据，乐私塾使用<span lang="EN-US">cookies</span>可为用户提供个性化服务。
          如果拒绝所有<span lang="EN-US">&nbsp;cookies</span>，用户将不能使用需要登录的乐私塾产品及服务内容。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※用户协议的修改和完善</b><span lang="EN-US"><br /> </span> （<span lang="EN-US">1</span
          >）乐私塾将根据互联网的发展和法律、法规的变化，在认为必要时可以单方面修改用户协议。<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">2</span
          >）本用户协议一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，则视为接受用户协议的变动。当发生争议时，应以最新用户协议的内容为准。<span
            lang="EN-US"
            ><br />
          </span>
          乐私塾有权根据实际情况，调整网络课程的任课教师，该教师如与宣传材料不符以实际任课教师为准。乐私塾将最大限度的保护用户的听课质量。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">六、服务的中断和终止：</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          用户同意，在乐私塾未向用户收取服务费的情况下，乐私塾可自行全权决定以任何理由<span lang="EN-US">&nbsp;(</span
          >包括但不限于乐私塾认为用户已违反本协议的字面意义和精神，或以不符合本协议的字面意义和精神的方式行事，或用户在超过<span
            lang="EN-US"
            >90</span
          >天的时间内未以用户的账号及密码登录网站等<span lang="EN-US">)&nbsp;</span>终止用户的“服务”密码、账户<span
            lang="EN-US"
            >&nbsp;(</span
          >或其任何部份<span lang="EN-US">)&nbsp;</span
          >或用户对“服务”的使用，并删除（不再保存）用户在使用“服务”中提交的任何资料。同时乐私塾可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。账号终止后，乐私塾没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          此外，用户同意，乐私塾不就终止用户接入“服务”而对用户或任何第三者承担任何责任。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          如用户向乐私塾提出注销乐私塾网注册用户身份时，经乐私塾审核同意，由乐私塾注销该注册用户，用户即解除与乐私塾的用户协议关系。但注销该用户账号后，乐私塾仍保留下列权利：<span
            lang="EN-US"
            >&nbsp;<br />
          </span>
          （<span lang="EN-US">1</span>）用户注销后，乐私塾有权保留该用户的注册数据及以前的行为记录；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">2</span
          >）用户注销后，如用户在注销前在乐私塾网络教育平台上存在违法行为或违反合同的行为，乐私塾仍可行使本用户协议所规定的权利。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※在下列情况下，乐私塾可以通过注销用户的方式终止服务：</b><span lang="EN-US"><br /> </span> （<span
            lang="EN-US"
            >1</span
          >）在用户违反本用户协议相关规定时，乐私塾有权终止向该用户提供服务。乐私塾将在中断服务时通知用户。但如该用户在被乐私塾终止提供服务后，再一次直接或间接或以他人名义注册为乐私塾用户的，乐私塾有权再次单方面终止向该用户提供服务；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">2</span
          >）如乐私塾通过用户提供的信息与用户联系时，发现用户在注册时填写的电子邮箱已不存在或无法接收电子邮件的，经乐私塾以其它联系方式通知用户更改，而用户仍未能提供新的电子邮箱地址的，乐私塾有权终止向该用户提供服务；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">3</span
          >）一旦乐私塾发现用户注册数据中主要内容是虚假的，乐私塾有权随时终止向该用户提供服务；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span>）用户协议终止或更新时，用户明示不愿接受新的用户协议的；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">5</span>）它乐私塾认为需终止服务的情况。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">七、责任范围：</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          用户明确理解和同意，乐私塾不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿<span
            lang="EN-US"
            >&nbsp;(</span
          >无论乐私塾是否已被告知该等损害赔偿的可能性<span lang="EN-US">)</span>：<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">1</span>）使用或未能使用“服务；<span lang="EN-US"><br /> </span> （<span lang="EN-US"
            >2</span
          >）第三方未经批准的接入或第三方更改用户的传输数据或数据；<span lang="EN-US"><br /> </span> （<span
            lang="EN-US"
            >3</span
          >）第三方对“服务”的声明或关于“服务”的行为；或非因乐私塾的原因而引起的与“服务”有关的任何其它事宜，包括疏忽；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span
          >）用户明确理解并同意，如因其违反有关法律或者本协议之规定，使乐私塾遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对乐私塾提供补偿，包括合理的律师费用等。<span
            lang="EN-US"
            >&nbsp;</span
          ></span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※担保责任</b
          ><span lang="EN-US"><br /> </span>
          乐私塾不担保其服务一定能够满足用户的要求，也不担保其服务不会因各种客观原因中断。乐私塾拒绝提供担保，由用户自己承担系统受损或资料丢失的风险和责任。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">八、隐私权政策：</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※适用范围 </b><span lang="EN-US"><br /> </span>（<span lang="EN-US">1</span
          >）用户注册乐私塾网络教育平台账户时，用户根据乐私塾要求提供的个人注册信息；<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">2</span
          >）在用户使用乐私塾服务，参加乐私塾活动，或访问乐私塾网络教育平台时，乐私塾自动接收并记录的用户浏览器上的服务器数值，包括但不限于<span
            lang="EN-US"
            >IP</span
          >地址等数据及用户要求取用的网页记录；<span lang="EN-US"><br /> </span> （<span lang="EN-US">3</span
          >）乐私塾收集到的用户在使用乐私塾的有关数据，包括但不限于购买、听课等行为；<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">4</span>）乐私塾通过合法途径从商业伙伴处取得的用户个人数据。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※信息使用</b><span lang="EN-US"><br /> </span>（<span lang="EN-US">1</span
          >）乐私塾不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；<span lang="EN-US"><br /> </span>
          （<span lang="EN-US">2</span
          >）乐私塾亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，乐私塾有权立即终止与该用户的用户协议，查封其账号；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">3</span
          >）为服务用户的目的，乐私塾可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与乐私塾合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息（后者需要用户的事先同意）。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※信息披露</b><span lang="EN-US"><br /> </span> 用户的个人信息将在下述情况下部分或全部被披露：<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">1</span>）经用户同意，向第三方披露；<span lang="EN-US">&nbsp;<br /> </span> （<span
            lang="EN-US"
            >2</span
          >）如用户是合资格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">3</span
          >）根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；<span lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span>）如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">5</span>）为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">6</span>）其它乐私塾根据法律或者网站政策认为合适的披露。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※信息安全</b><span lang="EN-US"><br /> </span>（<span lang="EN-US">1</span
          >）乐私塾账户有安全保护功能，请妥善保管用户的账户及密码信息；<span lang="EN-US"><br /> </span> （<span
            lang="EN-US"
            >2</span
          >）如果用户发现自己的个人信息泄密，尤其是乐私塾账户及密码发生泄露，请用户立即联络乐私塾客服，以便乐私塾采取相应措施。</span
        >
      </p>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          <b> ※Cookie的使用</b><span lang="EN-US"><br /> </span> （<span lang="EN-US">1</span>）通过乐私塾所设<span
            lang="EN-US"
            >Cookie</span
          >所取得的有关信息，将适用本政策；<span lang="EN-US"><br /> </span> （<span lang="EN-US">2</span
          >）在乐私塾上发布广告的公司通过广告在用户计算机上设定的<span lang="EN-US">Cookies</span
          >，将按其自己的隐私权政策使用；<span lang="EN-US"><br /> </span> （<span lang="EN-US">3</span
          >）编辑和删除个人信息的权限： 用户可以点击“我的课堂”对用户的个人信息进行编辑和删除，除非乐私塾另有规定；<span
            lang="EN-US"
            ><br />
          </span>
          （<span lang="EN-US">4</span>）政策修改：乐私塾保留对本隐私权政策作出不时修改的权利。</span
        >
      </p> -->

    <!-- <h3 class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <b><span style="font-family: 宋体; color: black">九、法律与管辖：</span></b>
      </h3>

      <p class="MsoNormal" align="left" style="text-align: left; layout-grid-mode: char">
        <span style="font-family: 宋体; color: black">
          本用户协议根据现行中华人民共和国法律法规制定。如发生协议条款与中华人民共和国法律法规相抵触时，则这些条款将完全按法律法规的规定重新解释，本用户协议的其它条款仍对乐私塾和用户具有法律约束力。因本用户协议而发生的任何争议应向对厦门市集美区有管辖权的人民法院提起诉讼。</span
        >
      </p>

      <p class="MsoNormal" style="layout-grid-mode: char">
        <span lang="EN-US">&nbsp;</span>
      </p>

      <p class="MsoNormal" style="layout-grid-mode: char">
        <span lang="EN-US">&nbsp;</span>
      </p> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          title: '一、说明',
          data: [
            {
              txt: '本用户协议双方为厦门铸远教育科技有限公司（以下简称乐私塾）与乐私塾用户，本用户协议具有合同效力。'
            },
            {
              txt:
                '本用户协议内容包括协议正文及所有乐私塾已经发布的或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。'
            },
            {
              txt:
                '用户在使用乐私塾提供的各项服务的同时，承诺接受并遵守各项相关规则的规定。乐私塾有权根据需要不时地制定、修改本协议或各类规则，如本协议有任何变更，乐私塾将在网站及相关产品平台上刊载公告，通知予用户。如用户不同意相关变更，必须停止使用“服务”。经修订的协议一经在乐私塾公布后，立即自动生效。各类规则会在发布后生效，亦成为本协议的一部分。登录或继续使用“服务”将表示用户接受经修订的协议。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。'
            },
            {
              txt:
                '用户确认本用户协议后，本用户协议即在用户和乐私塾之间产生法律效力。请用户务必在注册之前认真阅读全部用户协议内容，如有任何疑问，可向乐私塾咨询。',
              tips: [
                {
                  txt:
                    '无论用户事实上是否在注册之前认真阅读了本用户协议，只要用户点击协议正本下方的“确认”按钮并按照乐私塾注册程序成功注册为用户，用户的行为仍然表示其同意并签署了本用户协议。'
                },
                {
                  txt: '本协议不涉及用户与乐私塾其它用户之间因网络教育而产生的法律关系及法律纠纷。'
                }
              ]
            }
          ]
        },
        {
          title: '二、定义',
          data: [
            {
              txt:
                '乐私塾网络教育平台：乐私塾旗下全部网络教育产品平台，包括但不限于Web H5 商城，乐私塾APP，微信小程序等。'
            },
            {
              txt:
                '用户及用户注册：用户必须是具备完全民事行为能力的自然人。无民事行为能力人、限制民事行为能力人不应注册为乐私塾用户，其与乐私塾之间的用户协议自始无效，乐私塾一经发现，有权立即注销该用户，并追究其使用乐私塾“服务”的一切法律责任。用户注册是指用户登录乐私塾网络教育平台，并按要求填写相关信息并确认同意履行相关用户协议的过程。用户因进行交易、获取有偿服务或接触乐私塾网络教育平台服务器而发生的所有应纳税赋，以及一切硬件、软件、服务及其它方面的费用均由用户负责支付。乐私塾仅作为网络教育培训平台。'
            }
          ]
        },
        {
          title: '三、用户权利和义务：',
          data: [
            {
              btxt: '※所有用户必须遵循',
              tips: [
                {
                  txt: '遵守所有使用网络服务的网络协议、规定、程序和惯例；不得使用乐私塾从事违法活动；'
                },
                {
                  txt: '不得干扰或侵犯乐私塾的正常运行和其他用户的正常使用；'
                },
                {
                  txt: '未经允许，不得以任何形式下载或试图下载乐私塾的任何内容；'
                },
                {
                  txt: '用户购买的课程只允许个人使用，不能用于其他目的；'
                },
                {
                  txt: '从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。'
                }
              ]
            },
            {
              btxt: '※同时用户承诺：',
              tips: [
                {
                  txt: '不得利用乐私塾网络教育平台制作、复制、查阅和传播下列信息：',
                  tips: [
                    {
                      txt: '任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；'
                    },
                    {
                      txt: '任何教唆他人进行违法犯罪行为的资料；'
                    },
                    {
                      txt: '不利于国内团结和社会安定的资料；'
                    },
                    {
                      txt: '任何不符合国家法律、法规规定的资料、信息；'
                    },
                    {
                      txt: '任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；'
                    }
                  ]
                },
                {
                  txt: '不得未经许可而非法进入其它个人或组织电脑系统；'
                },
                {
                  txt: '未经允许，不得对乐私塾网络教育平台中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；'
                },
                {
                  txt: '不得故意制作、传播计算机病毒等破坏性程序；'
                },
                {
                  txt: '法律规定的其他义务。'
                }
              ]
            },
            {
              txt:
                '如果用户的行为违背上述两款规定，乐私塾可以做出独立判断并有权立即取消用户资格。用户应对自己在乐私塾网络教育平台上的违法行为承担全部法律责任。'
            },
            {
              btxt: '※基于网络服务的特殊性，用户同意：',
              tips: [
                {
                  txt: '在注册时按照注册提示提供准确用户名和密码以及详尽的个人资料；'
                },
                {
                  txt:
                    '在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为乐私塾提供所有服务的有效身份依据。'
                },
                {
                  txt: '用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；'
                },
                {
                  txt: '用户应自行负担因使用这种接入方式而产生的上网电话费、上网信息费及教育信息费。'
                },
                {
                  txt: '用户的用户名、密码。',
                  tips: [
                    {
                      txt:
                        '用户一旦注册成功，成为乐私塾网络课堂的正式用户后，应当对自己的用户名（亦称账号）、密码的安全性负全部责任。用户的密码只能由用户自己掌握。'
                    },
                    {
                      txt:
                        '对于用户因账号或密码泄露造成的各种损失，乐私塾不承担任何责任。用户发现任何非法使用用户账号的情况，应立即通知乐私塾。'
                    },
                    {
                      txt: '用户应对以其用户名进行的所有活动和事件负责。'
                    },
                    {
                      txt:
                        '一个听课账号只能由一个用户使用，不允许多个用户使用同一个听课账号，如果用户违反此规定，乐私塾将有权将此听课账号作为无效处理并保留追究法律责任的权利。'
                    },
                    {
                      txt:
                        '用户应使用正版课程资料，对于涉嫌盗版听课账号，一经证实，乐私塾将有权将此听课账号做封号处理并保留追究法律责任的权利。'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          title: '四、关于乐私塾网络课堂的说明',
          data: [
            {
              tips: [
                {
                  txt:
                    '所有直播课程，一经购买（包括网上支付等各种购买方式），都不允许任何形式的退换。直播课程确有质量问题除外。'
                },
                {
                  txt:
                    '所有直播课程都有听课有效期，用户应在指定日期前登录直播课堂。如果用户没有在最后期限之前登录直播课堂，课程将自动失效，乐私塾不在予以任何补偿。'
                }
              ]
            }
          ]
        },
        {
          title: '五、乐私塾的权利和义务：',
          data: [
            {
              txt:
                '乐私塾有义务在现有技术上维护整个网络教育平台的正常运行，并努力提升和改进技术，使用户网络教育活动得以顺利进行；'
            },
            {
              txt:
                '对用户在注册使用乐私塾网络教育平台中所遇到的与交易或注册有关的问题及反映的情况，乐私塾应及时做出回复；'
            },
            {
              txt:
                '对于用户在乐私塾网络教育平台上的不当行为或其它任何乐私塾认为应当终止服务的情况，乐私塾有权随时做出删除相关信息、终止服务提供等处理，而无须征得用户的同意； 乐私塾应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于不可抗力或者其它非人为因素造成的服务的中断或停止，乐私塾不承担任何相应的责任。'
            },
            {
              txt:
                '乐私塾网站内以任何形式表现的作品（包括但不限于文字、软件、声音、图片、录像、表格、电子邮件等）的著作权，用户未经许可，不得擅自对乐私塾的包括电子课件在内的任何作品进行任何形式的翻录、复制或从事其他任何违反著作权法等相关法律、法规的活动。对侵犯乐私塾知识产权的个人和组织，乐私塾和作品的著作权人将依法追究其民事或刑事责任。'
            },
            {
              txt: '乐私塾享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务。'
            },
            {
              txt:
                '许可使用权：乐私塾对用户在网上发表的供学习交流的作品，享有独家的出版、发行和复制的权利。用户以此授予乐私塾及其关联公司独家的、全球通用的、永久的、免费的许可使用权利 (并有权在多个层面对该权利进行再授权)，使乐私塾及其关联公司有权(全部或部份地) 使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部资料数据（包括但不限于注册资料、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内；'
            },
            {
              txt:
                '乐私塾会在用户的计算机上设定或取用乐私塾网络教育平台cookies。 乐私塾允许那些在乐私塾网络教育平台上发布广告的公司到用户计算机上设定或取用 cookies 。 在用户登录时获取数据，乐私塾使用cookies可为用户提供个性化服务。 如果拒绝所有 cookies，用户将不能使用需要登录的乐私塾产品及服务内容。'
            },
            {
              btxt: '※用户协议的修改和完善',
              tips: [
                {
                  txt: '乐私塾将根据互联网的发展和法律、法规的变化，在认为必要时可以单方面修改用户协议。'
                },
                {
                  txt:
                    '本用户协议一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动放弃获得的网络服务。如果用户继续享用网络服务，则视为接受用户协议的变动。当发生争议时，应以最新用户协议的内容为准。'
                },
                {
                  txt:
                    '乐私塾有权根据实际情况，调整网络课程的任课教师，该教师如与宣传材料不符以实际任课教师为准。乐私塾将最大限度的保护用户的听课质量。'
                }
              ]
            }
          ]
        },
        {
          title: '六、服务的中断和终止：',
          data: [
            {
              txt:
                '用户同意，在乐私塾未向用户收取服务费的情况下，乐私塾可自行全权决定以任何理由 (包括但不限于乐私塾认为用户已违反本协议的字面意义和精神，或以不符合本协议的字面意义和精神的方式行事，或用户在超过90天的时间内未以用户的账号及密码登录网站等) 终止用户的“服务”密码、账户 (或其任何部份) 或用户对“服务”的使用，并删除（不再保存）用户在使用“服务”中提交的任何资料。同时乐私塾可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。账号终止后，乐私塾没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。'
            },
            {
              txt: '此外，用户同意，乐私塾不就终止用户接入“服务”而对用户或任何第三者承担任何责任。'
            },
            {
              txt:
                '如用户向乐私塾提出注销乐私塾网注册用户身份时，经乐私塾审核同意，由乐私塾注销该注册用户，用户即解除与乐私塾的用户协议关系。但注销该用户账号后，乐私塾仍保留下列权利： ',
              tips: [
                {
                  txt: '用户注销后，乐私塾有权保留该用户的注册数据及以前的行为记录；'
                },
                {
                  txt:
                    '用户注销后，如用户在注销前在乐私塾网络教育平台上存在违法行为或违反合同的行为，乐私塾仍可行使本用户协议所规定的权利。'
                }
              ]
            },
            {
              btxt: '※在下列情况下，乐私塾可以通过注销用户的方式终止服务：',
              tips: [
                {
                  txt:
                    '在用户违反本用户协议相关规定时，乐私塾有权终止向该用户提供服务。乐私塾将在中断服务时通知用户。但如该用户在被乐私塾终止提供服务后，再一次直接或间接或以他人名义注册为乐私塾用户的，乐私塾有权再次单方面终止向该用户提供服务；'
                },
                {
                  txt:
                    '如乐私塾通过用户提供的信息与用户联系时，发现用户在注册时填写的电子邮箱已不存在或无法接收电子邮件的，经乐私塾以其它联系方式通知用户更改，而用户仍未能提供新的电子邮箱地址的，乐私塾有权终止向该用户提供服务；'
                },
                {
                  txt: '一旦乐私塾发现用户注册数据中主要内容是虚假的，乐私塾有权随时终止向该用户提供服务；'
                },
                {
                  txt: '用户协议终止或更新时，用户明示不愿接受新的用户协议的；'
                },
                {
                  txt: '它乐私塾认为需终止服务的情况。'
                }
              ]
            }
          ]
        },
        {
          title: '七、责任范围：',
          data: [
            {
              txt:
                '用户明确理解和同意，乐私塾不对因下述任一情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿 (无论乐私塾是否已被告知该等损害赔偿的可能性)：',
              tips: [
                {
                  txt: '使用或未能使用“服务；'
                },
                {
                  txt: '第三方未经批准的接入或第三方更改用户的传输数据或数据；'
                },
                {
                  txt:
                    '第三方对“服务”的声明或关于“服务”的行为；或非因乐私塾的原因而引起的与“服务”有关的任何其它事宜，包括疏忽；'
                },
                {
                  txt:
                    '用户明确理解并同意，如因其违反有关法律或者本协议之规定，使乐私塾遭受任何损失，受到任何第三方的索赔，或任何行政管理部门的处罚，用户应对乐私塾提供补偿，包括合理的律师费用等。'
                }
              ]
            },
            {
              btxt: '※担保责任',
              tips: [
                {
                  txt:
                    '乐私塾不担保其服务一定能够满足用户的要求，也不担保其服务不会因各种客观原因中断。乐私塾拒绝提供担保，由用户自己承担系统受损或资料丢失的风险和责任。'
                }
              ]
            }
          ]
        },
        {
          title: '八、隐私权政策：',
          data: [
            {
              btxt: '※适用范围',
              tips: [
                {
                  txt: '用户注册乐私塾网络教育平台账户时，用户根据乐私塾要求提供的个人注册信息；'
                },
                {
                  txt:
                    '在用户使用乐私塾服务，参加乐私塾活动，或访问乐私塾网络教育平台时，乐私塾自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录；'
                },
                {
                  txt: '乐私塾收集到的用户在使用乐私塾的有关数据，包括但不限于购买、听课等行为；'
                },
                {
                  txt: '乐私塾通过合法途径从商业伙伴处取得的用户个人数据。'
                }
              ]
            },
            {
              btxt: '※信息使用',
              tips: [
                {
                  txt: '乐私塾不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；'
                },
                {
                  txt:
                    '乐私塾亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，乐私塾有权立即终止与该用户的用户协议，查封其账号；'
                },
                {
                  txt:
                    '为服务用户的目的，乐私塾可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与乐私塾合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息（后者需要用户的事先同意）。'
                }
              ]
            },
            {
              btxt: '※信息披露'
            },
            {
              txt: '用户的个人信息将在下述情况下部分或全部被披露：',
              tips: [
                {
                  txt: '经用户同意，向第三方披露； '
                },
                {
                  txt:
                    '如用户是合资格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；'
                },
                {
                  txt: '根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；'
                },
                {
                  txt: '如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；'
                },
                {
                  txt: '为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；'
                },
                {
                  txt: '其它乐私塾根据法律或者网站政策认为合适的披露。'
                }
              ]
            },
            {
              btxt: '※信息安全',
              tips: [
                {
                  txt: '乐私塾账户有安全保护功能，请妥善保管用户的账户及密码信息；'
                },
                {
                  txt:
                    '如果用户发现自己的个人信息泄密，尤其是乐私塾账户及密码发生泄露，请用户立即联络乐私塾客服，以便乐私塾采取相应措施。'
                }
              ]
            },
            {
              btxt: '※Cookie的使用',
              tips: [
                {
                  txt: '通过乐私塾所设Cookie所取得的有关信息，将适用本政策；'
                },
                {
                  txt: '在乐私塾上发布广告的公司通过广告在用户计算机上设定的Cookies，将按其自己的隐私权政策使用；'
                },
                {
                  txt:
                    '编辑和删除个人信息的权限： 用户可以点击“我的课堂”对用户的个人信息进行编辑和删除，除非乐私塾另有规定；'
                },
                {
                  txt: '政策修改：乐私塾保留对本隐私权政策作出不时修改的权利。'
                }
              ]
            }
          ]
        },
        {
          title: '九、法律与管辖：',
          data: [
            {
              txt:
                '本用户协议根据现行中华人民共和国法律法规制定。如发生协议条款与中华人民共和国法律法规相抵触时，则这些条款将完全按法律法规的规定重新解释，本用户协议的其它条款仍对乐私塾和用户具有法律约束力。因本用户协议而发生的任何争议应向对厦门市集美区有管辖权的人民法院提起诉讼。'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.wrap {
  font-family: 宋体;
  h3 {
    margin: 20px 0;
    font-size: 20px;
    color: #000;
    text-align: left;
    text-indent: 1em;
    font-weight: bold;
  }
  .normal {
    text-align: left;
    text-indent: 2em;
    -ms-layout-grid-mode: char;
  }
  .sub_norma {
    text-align: left;
    text-indent: 3em;
    -ms-layout-grid-mode: char;
    .sub_norma_tip {
      display: block;
      text-indent: 5em;
    }
  }
}
// h3 {
//   margin: 20px 0;
//   font-size: 20px;
//   color: #333333;
// }
.top {
  margin: 0 0 20px 0;
}
p {
  font-size: 16px;
  color: #333333;
  margin: 5px 0;
}
span {
  margin: 10px 0;
}
</style>
